import React, { useState, useRef, useCallback, useEffect } from "react";
import ReactCrop from "react-image-crop";
import Modal from "react-bootstrap/Modal";
import "react-image-crop/dist/ReactCrop.css";
import methods from "../../services/utility";
import Preloading from "../basics/Preloading";
import apiMethod from "../../services/api-service";

const LogoCropper = ({ changeLogo, isLogoUploading, logoSrc }) => {
  const [src, setSrc] = useState(null);
  const [crop, setCrop] = useState({
    unit: "px",
    x: 50,
    y: 50,
    width: 50,
    height: 50,
  });
  const [formatImg, setFormatImg] = useState(null);
  const [show, setShow] = useState(false);
  const [imgFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const imgRef = useRef(null);

  useEffect(() => {
    if (!methods.isNullOrEmptyString(logoSrc)) {
      setImageSrc(logoSrc);
    }
  }, [logoSrc]);

  const onSelectFile = (file) => {
    setFormatImg(file);
    const reader = new FileReader();
    reader.onload = () => {
      setSrc(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const handleFileInput = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      onSelectFile(file);
      handleShow();
    }
  };

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files?.[0];
    if (file) {
      onSelectFile(file);
      handleShow();
    }
  }, []);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const onImageLoad = (img) => {
    imgRef.current = img;
  };

  const getCroppedImage = async () => {
    if (!imgRef.current || !crop.width || !crop.height) return;

    const canvas = document.createElement("canvas");
    const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
    const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      imgRef.current,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    canvas.toBlob((blob) => {
      if (!blob) return;
      const file = new File([blob], formatImg.name, { type: formatImg.type });
      changeLogo(file);
    });
    handleClose();
  };

  const handleDeleteImage = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.deleteFile({ filePath: logoSrc });
      if (methods.showApiErrors(resp)) console.log(resp);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setImageFile("");
      setSrc(null);
      setFormatImg(null);
      setImageSrc("");
    }
  };

  useEffect(() => {
    if (!methods.isNullOrEmptyString(logoSrc)) {
      const imgFile = methods.normalImage(logoSrc, "logo");
      setImageFile(imgFile);
    }
  }, [logoSrc]);

  return (
    <div className="crop-wrapper">
      {loading && <Preloading />}
      {imageSrc ? (
        <div>
          <img src={imgFile} alt="CropImage" style={{ maxWidth: "100%" }} />
          <div className="delete-image">
            <button
              type="button"
              className="btn btn-outline-danger"
              onClick={handleDeleteImage}
            >
              <i className="bi bi-trash3 ms-1"></i>
            </button>
          </div>
        </div>
      ) : isLogoUploading ? (
        <div className="uploadfileloading form-control border-0">
          <span
            className="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
          <span role="status"> در حال بارگذاری ... </span>
        </div>
      ) : (
        <label
          onDrop={handleDrop}
          htmlFor="imageUpload"
          onDragOver={handleDragOver}
        >
          <p className="mb-0">تصویر را بکشید و اینجا بیاندازید</p>

          <input
            type="file"
            id="imageUpload"
            style={{ display: "none" }}
            accept=".jpg, .jpeg, .png"
            onChange={handleFileInput}
          />
        </label>
      )}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop={true}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="kitchen-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {src && (
              <div>
                <ReactCrop
                  crop={crop}
                  onChange={setCrop}
                  minWidth={50}
                  minHeight={50}
                  keepSelection={true}
                >
                  <img
                    src={src}
                    alt="source"
                    onLoad={(e) => onImageLoad(e.currentTarget)}
                    style={{ maxWidth: "100%" }}
                  />
                </ReactCrop>
              </div>
            )}
          </div>
          <button
            onClick={getCroppedImage}
            style={{
              marginTop: "10px",
              padding: "8px 16px",
              backgroundColor: "#007bff",
              color: "white",
              border: "none",
              width: "100%",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            کراپ کن
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default LogoCropper;
